import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CentralRiesgoIntegracionService } from '../../_services/central-riesgo-integracion.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CentralRiesgoIntegracion } from '../../_models/central-riesgo-integracion';
import { CentralRiesgoIntegracionXDia } from '../../_models/central-riesgo-integracion-x-dia';
import { CentralRiesgoIntegracionXDiaService } from '../../_services/central-riesgo-integracion-x-dia.service';
import { ListaService } from '../../_services/lista.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { EstadoService } from '../../_services/estado.service';
import { NavService } from '../../_services/_nav.service';

@Component( {
  selector: 'app-central-riesgo-integracion-detalle',
  templateUrl: 'central-riesgo-integracion-detalle.component.html'
} )

export class CentralRiesgoIntegracionDetalleComponent implements OnInit {
  columnas: any[];
  formulario: FormGroup;
  centralRiesgoIntegracion: CentralRiesgoIntegracion;
  centralRiesgoIntegracionXDia: CentralRiesgoIntegracionXDia;
  lisCentralRiesgoIntegracionXDia: CentralRiesgoIntegracionXDia[] = [];
  lisEstados: SelectItem[] = [];
  carInformacionInicial = false;
  necesitaDiaVigencia = false;
  necesitaRangoVigencia = false;
  rangoDias: any[] = [];
  guardando = false;
  carTabla = true;
  indEncendido = false;
  indConsulta = false;

  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private serCentralRiesgoIntegraciones: CentralRiesgoIntegracionService,
    private serCentralRiesgoIntegracionesXDia: CentralRiesgoIntegracionXDiaService,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private nav: NavService,
    private router: Router,
    private navServicio: NavService,
    private serEstados: EstadoService,
  ) {
  }

  ngOnInit() {
    this.carInformacionInicial = true;
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.serCentralRiesgoIntegraciones.obtener( params[ 'id' ] ).subscribe( cenRieInt => {
          this.centralRiesgoIntegracion = cenRieInt;
          this.indConsulta = this.centralRiesgoIntegracion.indicadorConsultaXSolicitud;
          this.indEncendido = this.centralRiesgoIntegracion.indicadorEncendido;
          this.necesitaDiaVigencia = this.centralRiesgoIntegracion.indicadorDiasVigencia;
          if ( !this.centralRiesgoIntegracion.indicadorDiasVigencia ) {
            this.serCentralRiesgoIntegracionesXDia.obtenerPorCentralRiesgoIntegracion( cenRieInt.idCentralRiesgoIntegracion ).subscribe( cenRieIntXDia => {
              const habilitado = cenRieIntXDia.find( x => x.indicadorHabilitado === true );
              if ( cenRieIntXDia && cenRieIntXDia.length > 0 && habilitado ) {
                this.necesitaRangoVigencia = true;
                this.lisCentralRiesgoIntegracionXDia = cenRieIntXDia;
                cenRieIntXDia.map( ( s: CentralRiesgoIntegracionXDia ) => {
                  const obj = {} as any;
                  obj.dia = s.dia;
                  obj.idCentralRiesgoIntegracionXDia = s.idCentralRiesgoIntegracionXDia;
                  obj.habilitado = s.indicadorHabilitado;
                  if ( obj.habilitado ) {
                    this.rangoDias = [ ...this.rangoDias, obj ];
                  }

                } );
                this.rangoDias.sort( function( a, b ) {
                  return a.dia - b.dia
                } );
              }
            } );
          }
          this.columnas = [
            { field: 'dia', header: this.navServicio.buscarMensaje( 'CENTRALRIESGO.LBL_DIA' ), sort: false }
          ];
          this.carTabla = false;
          this.carInformacionInicial = false;

        } );
      }
    } );


  }


  regresar( dirty: boolean = false ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.nav.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.router.navigate( [ 'apl/central-riesgo-integracion/' ] );
        },
        reject: () => {
        }
      } );
    } else {
      this.router.navigate( [ 'apl/central-riesgo-integracion/' ] );
    }
  }
}
